import { EthereumStakingValidatorInfo } from '#/data/react-query/queries/order-list';
import { assign } from 'lodash-es';
import React from 'react';
import { Hex } from 'viem';
import { InterpreterFrom, createMachine } from 'xstate';

interface MachineContext {
  target: EthereumStakingValidatorInfo | null;
  amount: bigint | null;
  transactionHash: Hex | null;
}
const machine = createMachine<MachineContext>({
  predictableActionArguments: true,
  preserveActionOrder: true,
  context: {
    target: null,
    amount: null,
    transactionHash: null,
  },
  initial: 'information',
  states: {
    information: {
      on: {
        NEXT: {
          target: 'transaction',
          actions: assign((context, event) => {
            const { amount } = event.data;
            return { amount };
          }),
        },
      },
    },
    transaction: {
      invoke: {
        src: 'onTransaction',
        onDone: {
          target: 'transactionReceipt',
          actions: assign((context, event) => {
            const { transactionHash } = event.data;
            return { transactionHash };
          }),
        },
        onError: 'information',
      },
    },
    transactionReceipt: {},
  },
});

const MachineContext = React.createContext(
  {} as InterpreterFrom<typeof machine>
);

export { MachineContext };

export default machine;
